import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { PipesModule } from "../../../pipes/pipes.module";
import { MaterialModule } from "../../../components/material/material.module";
import { CrearTipoProductoCategoriaComponent } from "./crear-tipo-producto-categoria/crear-tipo-producto-categoria.component";
import { CrearTipoProductoCategoriaDialog } from "./crear-tipo-producto-categoria/crear-tipo-producto-categoria-dialog/crear-tipo-producto-categoria-dialog.component";
import { EditarTipoProductoCategoriaComponent } from "./editar-tipo-producto-categoria/editar-tipo-producto-categoria.component";
import { EliminarTipoProductoCategoriaComponent } from "./eliminar-tipo-producto-categoria/eliminar-tipo-producto-categoria.component";
import { IrTipoProductoCategoriaComponent } from "./ir-tipo-producto-categoria/ir-tipo-producto-categoria.component";
import { TipoProductoCategoriaComponent } from "./tipo-producto-categoria/tipo-producto-categoria.component";
import { VerTipoProductoCategoriaComponent } from "./ver-tipo-producto-categoria/ver-tipo-producto-categoria.component";
import { TipoProductoCategoriaService } from "../../../providers/tipo-producto-categoria.service";
import { RouterModule } from "@angular/router";
import { EditarTipoProductoCategoriaDialog } from './editar-tipo-producto-categoria/editar-tipo-producto-categoria-dialog/editar-tipo-producto-categoria-dialog.component';
import { EliminarTipoProductoCategoriaDialog } from './eliminar-tipo-producto-categoria/eliminar-tipo-producto-categoria-dialog/eliminar-tipo-producto-categoria-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        MaterialModule,
        RouterModule,
    ],
    declarations: [
        CrearTipoProductoCategoriaComponent,
        CrearTipoProductoCategoriaDialog,
        EditarTipoProductoCategoriaComponent,
        EliminarTipoProductoCategoriaComponent,
        IrTipoProductoCategoriaComponent,
        TipoProductoCategoriaComponent,
        VerTipoProductoCategoriaComponent,
        EditarTipoProductoCategoriaDialog,
        EliminarTipoProductoCategoriaDialog,
    ],
    providers: [
        TipoProductoCategoriaService
    ],
    entryComponents: [
        CrearTipoProductoCategoriaDialog,
        EditarTipoProductoCategoriaDialog,
        EliminarTipoProductoCategoriaDialog,
    ],
    exports: [
        CrearTipoProductoCategoriaComponent,
        EditarTipoProductoCategoriaComponent,
        EliminarTipoProductoCategoriaComponent,
        IrTipoProductoCategoriaComponent,
        TipoProductoCategoriaComponent,
        VerTipoProductoCategoriaComponent,
    ]
})
export class TipoProductoCategoriaModule { }